import { makeStyles } from "@material-ui/core"

export const useStyles = makeStyles((theme) => ({
    labelNegrito: {
        fontWeight: 600,
    },
    divider: {
        marginTop: '8px'
    },
    inputText: {
        marginTop: '8px'
    }
}));